var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { RestServiceBase } from "@ane/core/lib/services/RestServiceBase";
import EnvironmentService from "@ane/core/lib/services/EnvironmentService";
class UsersResource extends RestServiceBase {
  constructor() {
    super(EnvironmentService.endpoints.legacy, "/api/");
  }
  /*
  / Retrieve user workspace/group affinity from ExP API.
  /
  / If workspace Id is provided, API will return the default MG for the specific workspace
  / If user has never been to this workspace, API returns null.
  /
  / If workspace Id is absent, API will return the last user visited workspace and default group.
  / If user has never been to control tower before, API will return null.
  */
  getUserManagementGroupV2(userAlias, workspaceId, timeout) {
    return __async(this, null, function* () {
      let address = `users/${userAlias}`;
      address += !!workspaceId ? `?workspaceId=${workspaceId}` : "";
      return yield this._get(address, timeout);
    });
  }
  updateUserManagementGroupV2(user) {
    return __async(this, null, function* () {
      const address = `users/${user.UserName}?managementGroup=${user.ManagementGroup}&workspaceId=${user.WorkspaceId}`;
      return yield this._post(null, address);
    });
  }
}
const UsersResource$1 = new UsersResource();
export {
  UsersResource,
  UsersResource$1 as default
};
//# sourceMappingURL=UserResources.js.map
